import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import './i18n';
import './index.css';

// start react only when all modules are loaded
window.setTimeout(() => {
    const root = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);
    root.render(<App />);
}, 0);
